import { useMutation } from "@tanstack/react-query";
import {
  LocalizationLanguage,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import { AxiosResponse } from "axios";

import { DOMAIN_USERS } from "../domain";

import { usersApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_ACCEPT_TERMS_AND_CONDITIONS = "ACCEPT_TERMS_AND_CONDITIONS";

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

const updateUserLanguage = async (
  localizationLanguage: LocalizationLanguage,
): Promise<AxiosResponse<void>> => {
  const response =
    await usersApi.usersControllerUpdateUserLanguage(localizationLanguage);

  return response;
};

export const useUpdateUserLanguage = (
  user: UserProfileDto | null,
): {
  updateUserLanguage: (localizationLanguage: LocalizationLanguage) => void;
  updateUserLanguageAsync: (
    localizationLanguage: LocalizationLanguage,
  ) => Promise<AxiosResponse<void>>;
  updateUserLanguageEnabled: boolean;
  updateUserLanguageError: unknown;
  isSuccessUpdateUserLanguage: boolean;
  isPendingUpdateUserLanguage: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { mutate, mutateAsync, isSuccess, isPending, error } = useMutation({
    mutationKey: [DOMAIN_USERS, ACTION_ACCEPT_TERMS_AND_CONDITIONS],
    mutationFn: enabled ? updateUserLanguage : undefined,
  });

  return {
    updateUserLanguage: mutate,
    updateUserLanguageAsync: mutateAsync,
    updateUserLanguageEnabled: enabled,
    updateUserLanguageError: error,
    isSuccessUpdateUserLanguage: isSuccess,
    isPendingUpdateUserLanguage: isPending,
  };
};
